import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Mail, ArrowRight } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext.js';
import { EduButton } from '../components/EduButton.js';

export const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await login(email, password);
      navigate('/dashboard');
    } catch (err: any) {
      setError(err.message || 'Falha na autenticação. Verifique os dados informados.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-surface-secondary flex flex-col justify-center items-center p-4">
      {/* Container */}
      <div className="w-full max-w-md">
        {/* Brand Logo & Slogan */}
        <div className="text-center mb-8">
          <img
            src="/logo-edurender.png"
            alt="EduRender"
            className="h-14 mx-auto object-contain mb-3"
          />
          <p className="text-sm font-medium text-txt-secondary">
            Do conteúdo à videoaula, automaticamente.
          </p>
        </div>

        {/* Auth Card */}
        <div className="bg-surface border border-bdr rounded-xl shadow-sm p-8">
          <div className="mb-6">
            <h2 className="text-lg font-bold text-txt-primary">Acessar Plataforma</h2>
            <p className="text-xs text-txt-secondary mt-1">
              Portal do Cliente EduRender para produção de videoaulas.
            </p>
          </div>

          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 text-status-error text-xs rounded-lg">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-xs font-semibold text-txt-primary mb-1.5">
                E-mail corporativo
              </label>
              <div className="relative">
                <Mail className="absolute left-3 top-2.5 text-txt-muted" size={16} />
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="seu.email@empresa.com.br"
                  className="w-full pl-9 pr-3 py-2 text-sm bg-surface border border-bdr rounded-md text-txt-primary placeholder:text-txt-muted focus:outline-none focus:border-brand-primary focus:ring-1 focus:ring-brand-primary"
                />
              </div>
            </div>

            <div>
              <div className="flex justify-between items-center mb-1.5">
                <label className="text-xs font-semibold text-txt-primary">
                  Senha
                </label>
                <a href="#recuperar" className="text-xs text-brand-primary hover:underline">
                  Esqueceu a senha?
                </a>
              </div>
              <div className="relative">
                <Lock className="absolute left-3 top-2.5 text-txt-muted" size={16} />
                <input
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  className="w-full pl-9 pr-3 py-2 text-sm bg-surface border border-bdr rounded-md text-txt-primary placeholder:text-txt-muted focus:outline-none focus:border-brand-primary focus:ring-1 focus:ring-brand-primary"
                />
              </div>
            </div>

            <EduButton
              type="submit"
              variant="primary"
              size="lg"
              className="w-full mt-2"
              isLoading={loading}
              icon={<ArrowRight size={16} />}
            >
              Entrar
            </EduButton>
          </form>
        </div>

        {/* Footer info */}
        <p className="text-center text-xs text-txt-muted mt-6">
          Ambiente seguro com criptografia e isolamento multi-tenant.
        </p>
      </div>
    </div>
  );
};
